module.exports = __webpack_public_path__ + "img/ИФ-1(А)-004-m.42408f34.png";